import React, {
  DetailedHTMLProps,
  ButtonHTMLAttributes,
  forwardRef,
} from 'react';
import { useFocusRing } from '@react-aria/focus';
import { mergeProps } from '@react-aria/utils';
import classnames from 'classnames';

export type RSLinkButtonProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

export const RSLinkButton = forwardRef<HTMLButtonElement, RSLinkButtonProps>(
  (props, ref) => {
    const { isFocusVisible, focusProps } = useFocusRing();

    const color = '#0066FF';

    return (
      <>
        <span
          className={classnames(
            'wrapper',
            isFocusVisible && 'focus-visible',
            'inline-block',
            'relative',
            'before:transition',
          )}
        >
          <button
            {...mergeProps(props, focusProps)}
            ref={ref}
            className={classnames(
              'button',
              'inline',
              'appearance-none',
              'p-0',
              'border-none',
              'bg-transparent',
              'relative',
              'underline',
              'underline-offset-4',
              'decoration-transparent',
              'transition-all',
              'outline-none',
              'focus:outline-none',
              'cursor-pointer',
            )}
          />
        </span>
        <style jsx>{`
          .wrapper::before {
            content: '';
            box-sizing: border-box;
            display: block;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            border-style: solid;
            border-width: 2px;
            border-color: transparent;
            border-radius: 5px;
          }

          .wrapper.focus-visible::before {
            border-color: ${color};
          }

          .button {
            font-weight: unset;
            letter-spacing: unset;
            color: ${color};
          }
          .button:hover {
            text-decoration-color: ${color};
          }
        `}</style>
      </>
    );
  },
);

RSLinkButton.displayName = 'RSLinkButton';
